// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import styles from "../styles/resultQuestionary.module.css";

import { logoutUser } from "../logoutUser";
import { userLogged } from "../userLogged";
import { verifyUserPaid } from "../verifyUserPaid";
import { Menu } from "./Menu";

import { Tooltip, BarChart, XAxis, YAxis, Bar, ResponsiveContainer, Legend } from 'recharts';
import axios from "axios";
import { urlAPI_Current } from "../config";

export function ProfileColumnsChart() {
  const [userData, setUserData] = useState([]);
  const [userSkills, setUserSkills] = useState([
      {
        nome: '',
        Ideal: 10,
        Real: 8.5,
        Você: 0,
      },
      {
        nome: '',
        Ideal: 10,
        Real: 8.5,
        Você: 0,
      },
      {
        nome: '',
        Ideal: 10,
        Real: 8.5,
        Você: 0,
      },
      {
        nome: '',
        Ideal: 10,
        Real: 8.5,
        Você: 0,
      }
    ]
  );

  async function getUserLogged(){
      try {
        const responseSkills = await axios.post(`${urlAPI_Current}/getProfile`, {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        });
        
        if (responseSkills.data.success === true) {
          const userInfo = responseSkills.data.user;
          setUserData(userInfo);
          console.log("Usuário possui dados");
        } else {
          console.log("Usuário não possui dados");
          toast.error("Erro ao carregar dados do usuário");
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        toast.error("Erro ao carregar dados do usuário");
      }
  }

  const data = userSkills.map(skill => ({
    nome: skill.nome || '',
    Você: skill.Você || 0,
    Ideal: skill.Ideal || 0,
    Real: skill.Real || 0,
  }));

  async function getUserSkills(){
    try {
      const responseSkills = await axios.post(`${urlAPI_Current}/getSkills`, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
      });

      if (responseSkills && responseSkills.data.userSkills) {
        
        const pontuacao_cognitivo = responseSkills.data.userSkills.pontuacao_cognitivo;
        const pontuacao_relacional = responseSkills.data.userSkills.pontuacao_relacional;
        const pontuacao_socioemocional = responseSkills.data.userSkills.pontuacao_socioemocional;

        const inteligencia_emocional = responseSkills.data.userSkills.inteligencia_emocional;
        const colaboracao_em_equipe = responseSkills.data.userSkills.colaboracao_em_equipe;
        const empatia = responseSkills.data.userSkills.empatia;
        const relacao_com_o_medo = responseSkills.data.userSkills.relacao_com_o_medo;

        const criatividade = responseSkills.data.userSkills.criatividade;
        const adaptabilidade = responseSkills.data.userSkills.adaptabilidade;
        const agilidade = responseSkills.data.userSkills.agilidade;
        const inteligencia_relacional = responseSkills.data.userSkills.inteligencia_relacional;

        const complexidade = responseSkills.data.userSkills.complexidade;
        const tomada_de_decisao = responseSkills.data.userSkills.tomada_de_decisao;
        const pensamento_critico = responseSkills.data.userSkills.pensamento_critico;
        const flexibilidade_cognitiva = responseSkills.data.userSkills.flexibilidade_cognitiva;

        let perfilDimensional = '';
        let maiorPontuacao = Math.max(pontuacao_cognitivo, pontuacao_relacional, pontuacao_socioemocional);

        // Verifica empates com base na prioridade definida pelo Luis no grupo
        if (
            pontuacao_cognitivo === pontuacao_relacional &&
            pontuacao_cognitivo === maiorPontuacao
        ) {
            perfilDimensional = 'Cognitivo';
        } else if (
            pontuacao_cognitivo === pontuacao_socioemocional &&
            pontuacao_cognitivo === maiorPontuacao
        ) {
            perfilDimensional = 'Cognitivo';
        } else if (
            pontuacao_relacional === pontuacao_socioemocional &&
            pontuacao_relacional === maiorPontuacao
        ) {
            perfilDimensional = 'Relacional';
        } else if (pontuacao_cognitivo === maiorPontuacao) { // se não empatar em nada, pega só maior mesmo
            perfilDimensional = 'Cognitivo';
        } else if (pontuacao_relacional === maiorPontuacao) {
            perfilDimensional = 'Relacional';
        } else {
            perfilDimensional = 'Socioemocional';
        }

        if (perfilDimensional === 'Cognitivo') {
            setUserSkills([
                {
                    nome: 'Complexidade',
                    Ideal: 10,
                    Real: 8.5,
                    Você: complexidade
                },
                {
                    nome: 'Tomada de Decisão',
                    Ideal: 10,
                    Real: 8.5,
                    Você: tomada_de_decisao
                },
                {
                    nome: 'Pensamento Crítico',
                    Ideal: 10,
                    Real: 8.5,
                    Você: pensamento_critico
                },
                {
                    nome: 'Flexibilidade Cognitiva',
                    Ideal: 10,
                    Real: 8.5,
                    Você: flexibilidade_cognitiva
                }
            ]);
        } else if (perfilDimensional === 'Relacional') {
            setUserSkills([
                {
                    nome: 'Criatividade',
                    Ideal: 10,
                    Real: 8.5,
                    Você: criatividade
                },
                {
                    nome: 'Adaptabilidade',
                    Ideal: 10,
                    Real: 8.5,
                    Você: adaptabilidade
                },
                {
                    nome: 'Agilidade',
                    Ideal: 10,
                    Real: 8.5,
                    Você: agilidade
                },
                {
                    nome: 'Inteligência Relacional',
                    Ideal: 10,
                    Real: 8.5,
                    Você: inteligencia_relacional
                }
            ]);
        } else {
            setUserSkills([
                {
                    nome: 'Inteligência Emocional',
                    Ideal: 10,
                    Real: 8.5,
                    Você: inteligencia_emocional
                },
                {
                    nome: 'Colaboração',
                    Ideal: 10,
                    Real: 8.5,
                    Você: colaboracao_em_equipe
                },
                {
                    nome: 'Empatia',
                    Ideal: 10,
                    Real: 8.5,
                    Você: empatia
                },
                {
                    nome: 'Relação com o Medo',
                    Ideal: 10,
                    Real: 8.5,
                    Você: relacao_com_o_medo
                }
            ]);
        }
        console.log("Habilidades carregadas");
    } else {
        console.log("Nenhuma habilidade encontrada");
        toast.error("Erro ao carregar habilidades");
      }
    } catch(err) {
      console.error("Erro ao buscar habilidades:", err);
      toast.error("Erro ao carregar habilidades");
    }
  }

  useEffect(() => {
    const loadData = async () => {
      await getUserLogged();
      await getUserSkills();
    };
    
    loadData();
  }, []);

  if (!userData || !userSkills) {
    return <div>Carregando dados...</div>;
  }

  return (
    <div id="RadarChart" className={styles.radarChart}>
      <div className={styles.chartContainer} style={{width: '900px', height: '600px'}}>
        <ResponsiveContainer>
            <BarChart data={data}>
                <XAxis dataKey="nome" />
                <YAxis domain={[0, 10]} ticks={[0, 2, 4, 6, 8, 10]} />
                <Tooltip />
                <Legend />
                <Bar dataKey="Ideal" fill="#D3D3D3" />
                <Bar dataKey="Real" fill="#FFA500" />
                <Bar dataKey="Você" fill="#4287f5" />
            </BarChart>
        </ResponsiveContainer>
      </div>
      
    </div>
  );
}